import { FC } from 'react';
import { OverlayHeader } from 'app/components/Dialogs';
import { ReactComponent as ConnexLogo } from 'resources/images/connex-solid.svg';
import { ReactComponent as SoundCloudLogo } from 'resources/images/soundcloud-solid.svg';
import { ReactComponent as TuneCoreLogo } from 'resources/images/tunecore-solid.svg';
import { ChakraSelectionCard } from 'app/components/Core/ChakraSelectionCard';
import { Box, Center, Flex } from '@chakra-ui/react';
import { ReleaseType } from 'types/releases';
import { useLabelV2FeatureFlag } from 'featureFlags';

export interface SelectReleaseTypeOverlayProps {
  onLabelV2ReleaseClick: () => void;
  onSoundCloudReleaseClick: () => void;
  onTuneCoreReleaseClick: () => void;
  enabledReleaseTypes?: ReleaseType[];
}

export const SelectReleaseTypeOverlay: FC<SelectReleaseTypeOverlayProps> = ({
  onLabelV2ReleaseClick,
  onSoundCloudReleaseClick,
  onTuneCoreReleaseClick,
  enabledReleaseTypes,
}) => {
  const { labelV2ReleaseEnabled } = useLabelV2FeatureFlag();
  return (
    <>
      <OverlayHeader headerText="Choose Release type" />
      <Box height="100%" maxHeight={580}>
        <Center minHeight="100%">
          <Flex
            justifyContent="center"
            py={4}
            gap={[4, 6, 6, 8, 24]}
            flexWrap="wrap"
          >
            {labelV2ReleaseEnabled && (
              <ChakraSelectionCard
                icon={<ConnexLogo />}
                heading="Connex"
                text="Create and send your release directly to your Label via the Connex integration"
                actionText="Create release"
                onClick={onLabelV2ReleaseClick}
                data-testid="release-type-card"
                mx={12}
              />
            )}
            {enabledReleaseTypes?.includes(ReleaseType.TUNECORE) && (
              <ChakraSelectionCard
                icon={<TuneCoreLogo />}
                heading="TuneCore"
                text="Create and export a release for distribution via TuneCore"
                actionText="Create release"
                onClick={onTuneCoreReleaseClick}
                data-testid="release-type-card"
                mx={12}
              />
            )}
            {enabledReleaseTypes?.includes(ReleaseType.SOUNDCLOUD) && (
              <ChakraSelectionCard
                icon={<SoundCloudLogo />}
                heading="SoundCloud"
                text="Create a release and upload it directly to SoundCloud"
                actionText="Create release"
                onClick={onSoundCloudReleaseClick}
                data-testid="release-type-card"
                mx={12}
              />
            )}
          </Flex>
        </Center>
      </Box>
    </>
  );
};
